import { deleteRequest, get, post, postfd, put } from "../helpers/apihelpers";

export const CreateClientService=async(data)=>{
    try {
        const result = await post(`api/customer/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateClientOfflineService=async(data)=>{
    try {
        const result = await post(`api/customer/create_offline_customer`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CheckClientExistService=async(data)=>{
    try {
        const result = await post(`api/customer/check_customer_exist`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const SendClientTextMessage=async(data)=>{
    try {
        const result = await post(`api/customer/send_text_message`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const ValidateClientDataInRealDBService=async(id)=>{
    try {
        const result = await post(`api/customer/check_customer_data_in_real_db/${id}`, {});
        return result;
    } catch (err) {
        return err.response;
    }
}


export const UpdateClientService=async(data,id)=>{
    try {
        const result = await put(`api/customer/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClientActiveStatusService=async(data,id)=>{
    try {
        const result = await put(`api/customer/update_active_status/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateVisitClientService=async(data,id)=>{
    try {
        const result = await put(`api/customer/visit_time_update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientService=async(page,text='',from_date,to_date,step,user,text1='',city='')=>{
    try {
        const result = await get(`api/customer/get?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&step=${step}&user=${user}&text1=${text1}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCheckClientAlreadyExistService=async(data)=>{
    try {
        const result = await post(`api/customer/check_customer_exist`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetOfflineClientService=async(page,text='',from_date,to_date,step,class_room='',attendance_date='',city='')=>{
    try {
        const result = await get(`api/customer/get_offline?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&step=${step}&class_room=${class_room}&attendance_date=${attendance_date}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetTrackEmployeeWorkStatusService=async(date,user)=>{
    try {
        const result = await get(`api/user/work_status?date=${date}&user=${user}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTrackEmployeeWorkStatusUserService=async(from_date,to_date,user)=>{
    try {
        const result = await get(`api/user/work_status_user?from_date=${from_date}&to_date=${to_date}&user=${user}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientAnalyticsService=async(page,text,from_date,to_date,step,user,subscribed_status,city='')=>{
    try {
        const result = await get(`api/customer/get_analytics?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&step=${step}&user=${user}&subscribed_status=${subscribed_status}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetReTargetClientAnalyticsService=async(page,text,from_date,to_date,user,source_system,subscribed_status,text1,city='')=>{
    try {
        const result = await get(`api/customer/get_analytics_re_target?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&user=${user}&source_system=${source_system}&subscribed_status=${subscribed_status}&text1=${text1}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientVisibalityAdminService=async(page,text,from_date,to_date,city='')=>{
    try {
        const result = await get(`api/customer/get_new_clients_visibility_disabled?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientDetailService=async(id)=>{
    try {
        const result = await get(`api/customer/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteClientService=async(id)=>{
    try {
        const result = await deleteRequest(`api/customer/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DownloadClientService=async(page,text,from_date,to_date,step,user,text1)=>{
    try {
        const result = await get(`api/customer/download_data?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&step=${step}&user=${user}&text1=${text1}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadClientService=async(data)=>{
    try {
        const result = await postfd(`api/customer/upload_file`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const CreateClientCallService = async(data)=>{
 try {
        const result = await post(`api/customer/createCustomerCall`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClientCallService=async(data,id)=>{
    try {
        const result = await put(`api/customer/updatecallToCustomer/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteClientCallService=async(id)=>{
    try {
        const result = await deleteRequest(`api/customer/deletecallToCustomer/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetClientCallService=async(page,text,from_date,to_date,client)=>{
    try {
        const result = await get(`api/customer/getCustomerCall/${client}?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientSubscribedBasedWFHEmployeeService=async(page,text,from_date,to_date,user,user1,step)=>{
    try {
        const result = await get(`api/customer/getSubscribedBasedWFHEmployee?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&user=${user}&user1=${user1}&step=${step}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const TransferClientService = async(data)=>{
    try {
        const result = await post(`api/customer/transferClients`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadExcelClientService = async(data)=>{
    try {
        const result = await postfd(`api/customer/upload_client`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadTeacherExcelClientService = async(data)=>{
    try {
        const result = await postfd(`api/customer/upload_client_to_teacher`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const CreateClientCallScheduleService = async(data)=>{
 try {
        const result = await post(`api/customer/createCustomerCallSchedule`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClientCallScheduleService = async(data,id)=>{
 try {
        const result = await put(`api/customer/updateCustomerCallSchedule/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetClientCallScheduleService = async(page,text,from_date,to_date,step,step1,city='')=>{
 try {
        const result = await get(`api/customer/getCustomerCallSchedule?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&step1=${step1}&step=${step}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetAdminClientCallScheduleService = async(page,text,from_date,to_date,step,step1,city='')=>{
 try {
        const result = await get(`api/customer/getCustomerCallScheduleAdmin?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&step1=${step1}&step=${step}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeleteClientCallScheduleService = async(id)=>{
 try {
        const result = await deleteRequest(`api/customer/deleteCustomerCallSchedule/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetCustomerChatService=async(page,from_date,to_date,text,type)=>{
    try {
        const result = await get(`api/customer/get_customer_chat?page=${page}&from_date=${from_date}&to_date=${to_date}&type=${type}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const SendTelinfyBulkSMSService = async(data)=>{
 try {
        const result = await post(`api/customer/sendtelinfy_template_bulksms`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}
